import bio from './en/bio.json';
import contact from './en/contact.json';
import credentials from './en/credentials.json';
import landing from './en/landing.json';
import offerings from './en/offerings.json';
import portfolio from './en/portfolio.json';

/**
 * Static English content for the site. Mirrors the reference project's i18n
 * bundle; each page reads its slice from here so copy can be edited in one
 * place without touching layout code.
 */
export const en = {
  landing,
  bio,
  offerings,
  credentials,
  contact,
  portfolio,
};

export type Content = typeof en;
